module.exports = __webpack_public_path__ + "static/img/avatar.5128c944.png";